/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {TSErfassungsArt} from '../../models/enums/TSErfassungsArt';
import {TSRole} from '../../models/enums/TSRole';
import {TSSchadenfallEvent} from '../../models/enums/TSSchadenfallEvent';
import {TSSchadenfallStatus} from '../../models/enums/TSSchadenfallStatus';
import TSStatuswechsel from '../../models/TSStatuswechsel';
import BegruendungscodeMapperService from './BegruendungscodeMapperService';
import {PageNameConstants} from './PageNameConstants';
import ILogService = angular.ILogService;

export default class StatuswechselService {

    private statusMap: Array<TSStatuswechsel> = [];

    static $inject = ['$log', 'PAGE_NAMES', 'BegruendungscodeMapperService'];

    /* @ngInject */
    constructor(private $log: ILogService, private pageNames: PageNameConstants,
                private begrundugnscodeMapperService: BegruendungscodeMapperService) {

        let inBearbeitungASWechsel = new TSStatuswechsel(
            TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE,
            this.begrundugnscodeMapperService.initBegruedungscodesForStatus(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE),
            ['CHECK_BEARBEITUNG_AS_1', 'CHECK_BEARBEITUNG_AS_2', 'CHECK_BEARBEITUNG_AS_3', 'CHECK_BEARBEITUNG_AS_4'],
            [TSSchadenfallEvent.ANLAUFSTELLE_BASISPRUEFUNG_OK, TSSchadenfallEvent.STICHENTSCHEID_ANGEFORDERT],
            [TSRole.ANLAUFSTELLE_SACHBEARBEITER, TSRole.FONDSSUISSE_ADMIN, TSRole.SUPER_ADMIN],
            pageNames.SCHADENMELDUNG,
            [TSErfassungsArt.ONLINE, TSErfassungsArt.PAPIER]
        );
        this.statusMap.push(inBearbeitungASWechsel);

        let inBearbeitungASStichentscheidFS = new TSStatuswechsel(
            TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, //In Bearbeitung bei fondssuisse für Ablehnung
            this.begrundugnscodeMapperService.initBegruedungscodesForStatus(TSSchadenfallStatus.IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS),
            ['CHECK_IN_BEARBEITUNG_ANLAUFSTELLE_STICHENTSCHEID_FS_1'],
            [TSSchadenfallEvent.STICHENTSCHEID_OK, TSSchadenfallEvent.ABLEHNUNG],
            [TSRole.FONDSSUISSE_SACHBEARBEITER, TSRole.FONDSSUISSE_ADMIN, TSRole.SUPER_ADMIN],
            pageNames.SCHADENMELDUNG,
            [TSErfassungsArt.ONLINE, TSErfassungsArt.PAPIER]
        );
        this.statusMap.push(inBearbeitungASStichentscheidFS);

        let schaetzungDurchgefuehrtWechsel = new TSStatuswechsel(
            TSSchadenfallStatus.AUFTRAG_SCHAETZER,
            this.begrundugnscodeMapperService.initBegruedungscodesForStatus(TSSchadenfallStatus.AUFTRAG_SCHAETZER),
            ['CHECK_AUFTRAG_SCHAETZER_1', 'CHECK_AUFTRAG_SCHAETZER_2', 'CHECK_AUFTRAG_SCHAETZER_3', 'CHECK_AUFTRAG_SCHAETZER_4'],
            [TSSchadenfallEvent.SCHAETZUNG_DURCHGEFUEHRT],
            [TSRole.ANLAUFSTELLE_SCHAETZER, TSRole.FONDSSUISSE_ADMIN, TSRole.SUPER_ADMIN],
            pageNames.SCHAETZUNG,
            [TSErfassungsArt.ONLINE, TSErfassungsArt.PAPIER]
        );
        this.statusMap.push(schaetzungDurchgefuehrtWechsel);

        let ueberpruefungAnlaufstelleWechsel = new TSStatuswechsel(
            TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE,
            this.begrundugnscodeMapperService.initBegruedungscodesForStatus(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE),
            ['CHECK_UEBERPRUEFUNG_AS_1', 'CHECK_UEBERPRUEFUNG_AS_2', 'CHECK_UEBERPRUEFUNG_AS_3', 'CHECK_UEBERPRUEFUNG_AS_4'],
            [TSSchadenfallEvent.ANLAUFSTELLE_SCHAETZUNG_OK, TSSchadenfallEvent.STICHENTSCHEID_ANGEFORDERT, TSSchadenfallEvent.ZURUECK_AN_SCHAETZER],
            [TSRole.ANLAUFSTELLE_SACHBEARBEITER, TSRole.FONDSSUISSE_ADMIN, TSRole.SUPER_ADMIN],
            pageNames.SCHAETZUNG,
            [TSErfassungsArt.ONLINE, TSErfassungsArt.PAPIER]
        );
        this.statusMap.push(ueberpruefungAnlaufstelleWechsel);

        let ueberpruefungASStichentscheidFS = new TSStatuswechsel(
            TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS, //Überprüfung bei fondssuisse für Ablehnung
            this.begrundugnscodeMapperService.initBegruedungscodesForStatus(TSSchadenfallStatus.UEBERPRUEFUNG_ANLAUFSTELLE_STICHENTSCHEID_FS),
            ['CHECK_UEBERPRUEFUNG_AS_STICHENTSCHEID_FS_1'],
            [TSSchadenfallEvent.STICHENTSCHEID_OK, TSSchadenfallEvent.ABLEHNUNG],
            [TSRole.FONDSSUISSE_SACHBEARBEITER, TSRole.FONDSSUISSE_ADMIN, TSRole.SUPER_ADMIN],
            pageNames.SCHAETZUNG,
            [TSErfassungsArt.ONLINE, TSErfassungsArt.PAPIER]
        );
        this.statusMap.push(ueberpruefungASStichentscheidFS);

        let ueberpruefungFSWechselOnline = new TSStatuswechsel(
            TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE,
            this.begrundugnscodeMapperService.initBegruedungscodesForStatus(TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE),
            ['CHECK_UEBERPRUEFUNG_FS_1', 'CHECK_UEBERPRUEFUNG_FS_2', 'CHECK_UEBERPRUEFUNG_FS_3', 'CHECK_UEBERPRUEFUNG_FS_4',
                'CHECK_UEBERPRUEFUNG_FS_5', 'CHECK_UEBERPRUEFUNG_FS_6', 'CHECK_UEBERPRUEFUNG_FS_7', 'CHECK_UEBERPRUEFUNG_FS_8',
                'CHECK_UEBERPRUEFUNG_FS_9', 'CHECK_UEBERPRUEFUNG_FS_11', 'CHECK_UEBERPRUEFUNG_FS_12', 'CHECK_UEBERPRUEFUNG_FS_13'],
            [TSSchadenfallEvent.FS_UEBERPRUEFUNG_OK, TSSchadenfallEvent.FS_UEBERPRUEFUNG_MANGELHAFT, TSSchadenfallEvent.ABLEHNUNG],
            [TSRole.FONDSSUISSE_SACHBEARBEITER, TSRole.FONDSSUISSE_ADMIN, TSRole.SUPER_ADMIN],
            pageNames.SCHAETZUNG,
            [TSErfassungsArt.ONLINE]
        );
        this.statusMap.push(ueberpruefungFSWechselOnline);

        let ueberpruefungFSWechselPapier = new TSStatuswechsel(
            TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE,
            this.begrundugnscodeMapperService.initBegruedungscodesForStatus(TSSchadenfallStatus.UEBERPRUEFUNG_FONDSSUISSE),
            ['CHECK_UEBERPRUEFUNG_FS_1', 'CHECK_UEBERPRUEFUNG_FS_2', 'CHECK_UEBERPRUEFUNG_FS_3', 'CHECK_UEBERPRUEFUNG_FS_4',
                'CHECK_UEBERPRUEFUNG_FS_5', 'CHECK_UEBERPRUEFUNG_FS_6', 'CHECK_UEBERPRUEFUNG_FS_7', 'CHECK_UEBERPRUEFUNG_FS_8',
                'CHECK_UEBERPRUEFUNG_FS_9', 'CHECK_UEBERPRUEFUNG_FS_11', 'CHECK_UEBERPRUEFUNG_FS_12', 'CHECK_UEBERPRUEFUNG_FS_13'],
            [TSSchadenfallEvent.FS_UEBERPRUEFUNG_OK_PAPIER, TSSchadenfallEvent.FS_UEBERPRUEFUNG_MANGELHAFT, TSSchadenfallEvent.ABLEHNUNG],
            [TSRole.FONDSSUISSE_SACHBEARBEITER, TSRole.FONDSSUISSE_ADMIN, TSRole.SUPER_ADMIN],
            pageNames.SCHAETZUNG,
            [TSErfassungsArt.PAPIER]
        );
        this.statusMap.push(ueberpruefungFSWechselPapier);

        let wiederherstellungWechsel = new TSStatuswechsel(
            TSSchadenfallStatus.WIEDERHERSTELLUNG,
            this.begrundugnscodeMapperService.initBegruedungscodesForStatus(TSSchadenfallStatus.WIEDERHERSTELLUNG),
            ['CHECK_WIEDERHERSTELLUG_1', 'CHECK_WIEDERHERSTELLUG_2', 'CHECK_WIEDERHERSTELLUG_3', 'CHECK_WIEDERHERSTELLUG_4', 'CHECK_WIEDERHERSTELLUG_5'],
            [TSSchadenfallEvent.WIEDERHERSTELLUNG_AUSGEFUEHRT],
            [TSRole.BETROFFENER, TSRole.ANLAUFSTELLE_SCHAETZER, TSRole.SUPER_ADMIN],
            pageNames.AUFWAENDE,
            [TSErfassungsArt.ONLINE]
        );
        this.statusMap.push(wiederherstellungWechsel);

        let ueberpruefungSchaetzerOnline = new TSStatuswechsel(
            TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER,
            this.begrundugnscodeMapperService.initBegruedungscodesForStatus(TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER),
            ['CHECK_UEBERPRUEFUNG_SCHAETZER_1', 'CHECK_UEBERPRUEFUNG_SCHAETZER_2', 'CHECK_UEBERPRUEFUNG_SCHAETZER_3',
                'CHECK_UEBERPRUEFUNG_SCHAETZER_4', 'CHECK_UEBERPRUEFUNG_SCHAETZER_5'],
            [TSSchadenfallEvent.WIEDERHERSTELLUNG_GEPRUEFT, TSSchadenfallEvent.WIEDERHERSTELLUNG_MANGELHAFT],
            [TSRole.ANLAUFSTELLE_SCHAETZER, TSRole.FONDSSUISSE_ADMIN, TSRole.SUPER_ADMIN],
            pageNames.AUFWAENDE,
            [TSErfassungsArt.ONLINE]
        );
        this.statusMap.push(ueberpruefungSchaetzerOnline);

        let ueberpruefungSchaetzerPapier = new TSStatuswechsel(
            TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER,
            this.begrundugnscodeMapperService.initBegruedungscodesForStatus(TSSchadenfallStatus.UEBERPRUEFUNG_SCHAETZER),
            ['CHECK_UEBERPRUEFUNG_SCHAETZER_1', 'CHECK_UEBERPRUEFUNG_SCHAETZER_2', 'CHECK_UEBERPRUEFUNG_SCHAETZER_3',
                'CHECK_UEBERPRUEFUNG_SCHAETZER_4', 'CHECK_UEBERPRUEFUNG_SCHAETZER_5'],
            [TSSchadenfallEvent.WIEDERHERSTELLUNG_GEPRUEFT_PAPIER],
            [TSRole.ANLAUFSTELLE_SCHAETZER, TSRole.FONDSSUISSE_ADMIN, TSRole.SUPER_ADMIN],
            pageNames.AUFWAENDE,
            [TSErfassungsArt.PAPIER]
        );
        this.statusMap.push(ueberpruefungSchaetzerPapier);

        let schadenBehobenAbrechnung = new TSStatuswechsel(
            TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN,
            this.begrundugnscodeMapperService.initBegruedungscodesForStatus(TSSchadenfallStatus.SCHADEN_BEHOBEN_ABRECHNEN),
            ['CHECK_SCHADENBEHOBEN_ABR_1', 'CHECK_SCHADENBEHOBEN_ABR_2', 'CHECK_SCHADENBEHOBEN_ABR_3', 'CHECK_SCHADENBEHOBEN_ABR_4'],
            [TSSchadenfallEvent.ABRECHNUNG_OK, TSSchadenfallEvent.ABRECHNUNG_MANGELHAFT, TSSchadenfallEvent.ABLEHNUNG],
            [TSRole.FONDSSUISSE_SACHBEARBEITER, TSRole.FONDSSUISSE_ADMIN, TSRole.SUPER_ADMIN],
            pageNames.ENTSCHAEDIGUNG,
            [TSErfassungsArt.ONLINE, TSErfassungsArt.PAPIER]
        );
        this.statusMap.push(schadenBehobenAbrechnung);

        let freigabeFSPapier = new TSStatuswechsel(
            TSSchadenfallStatus.NEU_PAPIER_FS,
            this.begrundugnscodeMapperService.initBegruedungscodesForStatus(TSSchadenfallStatus.NEU_PAPIER_FS),
            ['CHECK_UEBERPRUEFUNG_AS_1', 'CHECK_UEBERPRUEFUNG_AS_2', 'CHECK_UEBERPRUEFUNG_AS_3', 'CHECK_UEBERPRUEFUNG_AS_4',
                'CHECK_AUFTRAG_SCHAETZER_1', 'CHECK_AUFTRAG_SCHAETZER_2', 'CHECK_AUFTRAG_SCHAETZER_3', 'CHECK_AUFTRAG_SCHAETZER_4'],
            [TSSchadenfallEvent.FREIGABE_PAPIER_FS_6, TSSchadenfallEvent.FREIGABE_PAPIER_FS_9],
            [TSRole.FONDSSUISSE_SACHBEARBEITER, TSRole.FONDSSUISSE_ADMIN, TSRole.SUPER_ADMIN],
            pageNames.SCHADENMELDUNG,
            [TSErfassungsArt.PAPIER]
        );
        this.statusMap.push(freigabeFSPapier);

    }

    /**
     *
     * @param {TSSchadenfallStatus} currentStatus
     * @return {TSStatuswechsel} Object containing metadata like alalowed roles and keys for the checklist for the
     *         state that the schadenfall is in
     */
    public getStatuswechselMetadata(currentStatus: TSSchadenfallStatus,
                                    erfassungsart: TSErfassungsArt): TSStatuswechsel | undefined {

        let foundWechsel = this.statusMap
            .filter(value => value.status === currentStatus)
            .filter(value => value.allowedErfassungsArt.indexOf(erfassungsart) !== -1);
        if (foundWechsel.length === 0) {
            return undefined;
        } else {
            if (foundWechsel.length > 1) {
                this.$log.error('found more than one possible StatusWechsel')
            }
            return foundWechsel[0];
        }

    }

}



// WEBPACK FOOTER //
// ./src/app/core/service/StatuswechselService.ts